var _path, _path2, _path3, _path4, _path5, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 56,
    viewBox: "0 0 32 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.10107 46.3925C1.10107 45.0523 1.63345 43.767 2.58109 42.8194C3.52873 41.8717 4.81401 41.3394 6.15417 41.3394H26.3666C27.7067 41.3394 28.992 41.8717 29.9397 42.8194C30.8873 43.767 31.4197 45.0523 31.4197 46.3925V49.7612C31.4197 51.1014 30.8873 52.3866 29.9397 53.3343C28.992 54.2819 27.7067 54.8143 26.3666 54.8143H6.15417C4.81401 54.8143 3.52873 54.2819 2.58109 53.3343C1.63345 52.3866 1.10107 51.1014 1.10107 49.7612V46.3925Z",
    fill: "black",
    fillOpacity: 0.16,
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83789 48.0767V48.0932Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83789 48.0767V48.0932",
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5762 48.0767H24.6824Z",
    fill: "black",
    fillOpacity: 0.16
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5762 48.0767H24.6824",
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.10107 32.9174C1.10107 31.5772 1.63345 30.2919 2.58109 29.3443C3.52873 28.3966 4.81401 27.8643 6.15417 27.8643H26.3666C27.7067 27.8643 28.992 28.3966 29.9397 29.3443C30.8873 30.2919 31.4197 31.5772 31.4197 32.9174V36.2861C31.4197 37.6263 30.8873 38.9115 29.9397 39.8592C28.992 40.8068 27.7067 41.3392 26.3666 41.3392H6.15417C4.81401 41.3392 3.52873 40.8068 2.58109 39.8592C1.63345 38.9115 1.10107 37.6263 1.10107 36.2861V32.9174Z",
    fill: "black",
    fillOpacity: 0.16,
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83838 34.6016V34.6181Z",
    fill: "black",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83838 34.6016V34.6181",
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5762 34.6016H24.6824Z",
    fill: "black",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5762 34.6016H24.6824",
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.10107 19.4423C1.10107 18.1021 1.63345 16.8168 2.58109 15.8692C3.52873 14.9215 4.81401 14.3892 6.15417 14.3892H26.3666C27.7067 14.3892 28.992 14.9215 29.9397 15.8692C30.8873 16.8168 31.4197 18.1021 31.4197 19.4423V22.811C31.4197 24.1512 30.8873 25.4364 29.9397 26.3841C28.992 27.3317 27.7067 27.8641 26.3666 27.8641H6.15417C4.81401 27.8641 3.52873 27.3317 2.58109 26.3841C1.63345 25.4364 1.10107 24.1512 1.10107 22.811V19.4423Z",
    fill: "black",
    fillOpacity: 0.16,
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83838 21.1265V21.143Z",
    fill: "black",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83838 21.1265V21.143",
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5762 21.1265H24.6824Z",
    fill: "black",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5762 21.1265H24.6824",
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.10107 5.96765C1.10107 4.62749 1.63345 3.34221 2.58109 2.39457C3.52873 1.44693 4.81401 0.914551 6.15417 0.914551H26.3666C27.7067 0.914551 28.992 1.44693 29.9397 2.39457C30.8873 3.34221 31.4197 4.62749 31.4197 5.96765V9.33638C31.4197 10.6766 30.8873 11.9618 29.9397 12.9095C28.992 13.8571 27.7067 14.3895 26.3666 14.3895H6.15417C4.81401 14.3895 3.52873 13.8571 2.58109 12.9095C1.63345 11.9618 1.10107 10.6766 1.10107 9.33638V5.96765Z",
    fill: "black",
    fillOpacity: 0.16,
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83838 7.65186V7.6684Z",
    fill: "black",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83838 7.65186V7.6684",
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5762 7.65186H24.6824Z",
    fill: "black",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5762 7.65186H24.6824",
    stroke: "black",
    strokeWidth: 1.11766,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingle1);
export default __webpack_public_path__ + "static/media/single1.192ece8b4b4368e9d57506806a73fb5b.svg";
export { ForwardRef as ReactComponent };